import ReactSelect from "react-select";
import { useEffect, useState } from "react";
import i18next from 'i18next'
import { languageList } from "@data/language-list";
import { changeLanguage } from "@services/admin.fixransomware.com/client";
import { isRequestorHasToken, setAcceptLanguage } from "@services/admin.fixransomware.com";







export function SelectLanguageOption(){

  function handleOnChange(e: {image: any, label: string, value: "en" | "id"}){
    console.log("diubah lewat sini YGY...")
    i18next.changeLanguage(e.value);
    setAcceptLanguage(e.value);
    // change language for this user

    const isTokenExists = isRequestorHasToken();
    console.log(isTokenExists);
    if(!isTokenExists) return;
    try {
      console.log("language changed YGY")
      changeLanguage(e.value);
    } catch (error) {
      console.error("unauthorized user, but it should change the language in client")
    }
  }

  function getDefaultValue(){
    if(i18next.resolvedLanguage === "en") return languageList[0]
    if(i18next.resolvedLanguage === "id") return languageList[1]
    if(i18next.resolvedLanguage === "ar") return languageList[2] 
    if(i18next.resolvedLanguage === "es") return languageList[3]
    if(i18next.resolvedLanguage === "hi") return languageList[4]
    if(i18next.resolvedLanguage === "ko") return languageList[5]
    if(i18next.resolvedLanguage === "zh") return languageList[6]
    if(i18next.resolvedLanguage === "th") return languageList[7]
    if(i18next.resolvedLanguage === "jp") return languageList[8]
  }

  return (
    <ReactSelect
      key={i18next.resolvedLanguage}
      className="z-30 bg-transparent cursor-pointer w-16"
      components={{ DropdownIndicator: () => null }}
      styles={{
        control: (provided) => ({
          ...provided,
          backgroundColor: 'transparent', // Set background color of the control (input box)
          border: "none",
          cursor: "pointer"
        }),
        indicatorSeparator: (provided) => ({
          ...provided,
          display: 'none',
          cursor: "pointer"
        }),
        menu: (provided) => ({
          ...provided,
          backgroundColor: 'white', // Set background color of the dropdown menu
        }),
      }}
      // @ts-expect-error should be fine
      onChange={handleOnChange}
      options={languageList}
      defaultValue={getDefaultValue()}
      isSearchable={false}
      formatOptionLabel={language => (
        <div className="inline-flex gap-2 text-primary">
          <img src={language.image} alt="language-image" height={10} className="max-h-5" />
        </div>
      )}
      data-testid="language-changeLanguage-select"
    />

  )
}